// Azir — Shifting Sands: spawns a sand soldier behind the farthest enemy,
// dashes to the soldier (dealing magic damage to all enemies in the path),
// then dashes back to his starting position.

import { magicDamage } from "../../combat/DamageCalc";
import { effectiveStats } from "../UnitStats";
import type { Ability, AbilityHit } from "./Ability";

export const azirSoldier: Ability = {
  id: "azirSoldier",
  displayName: "Shifting Sands",
  description: "Azir spawns a sand soldier behind the farthest enemy, dashes through all enemies dealing 0.75× AP + 50 magic damage, then dashes back.",
  iconId: "AzirQ",

  targetShape({ caster, combat }) {
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    // Sort so last hex = farthest enemy (soldier spawn reference for animator)
    const enemies = combat.livingUnitsOf(enemyTeam).sort((a, b) =>
      caster.team === "player" ? a.pos.q - b.pos.q : b.pos.q - a.pos.q
    );
    return enemies.map(e => e.pos);
  },

  computeHits({ caster, combat }): AbilityHit[] {
    const enemyTeam = caster.team === "player" ? "enemy" : "player";
    const enemies = combat.livingUnitsOf(enemyTeam);
    const stats = effectiveStats(caster);
    const dmg = magicDamage(stats.ap * 0.75 + 50);

    return enemies.map(e => ({
      target: e,
      amount: dmg,
      type: "magical" as const,
      azirDash: true,
    }));
  },
};
